import { css } from '@emotion/css';
import {
  AlignItems,
  Color,
  Display,
  Font,
  FontWeight,
  JustifyContent,
  ScreenBreakpoint,
  Spacing,
  TextAlign,
} from 'src/styles';

export const offerName = css`
  ${FontWeight.bold}
  ${Font.h6}
  color: ${Color.Gray10};
`;

export const offerLogo = css`
  width: 32px;
  height: 32px;
  ${Spacing.mr16}
`;

export const totalInvestment = css`
  ${Font.h6}
  ${TextAlign.center}
  ${Spacing.my12}
  color: ${Color.Gray8};
`;

export const totalInvestmentValue = css`
  ${FontWeight.bold}
  ${Spacing.pl8}
`;

export const linkStyle = css`
  color: ${Color.Brand6};
  ${FontWeight.bold}
  cursor: pointer;
`;

export const nonAccreditContainer = css`
  ${Spacing.my12}
`;

export const policy = css`
  ${Spacing.mt16}
`;

export const termsAndConditions = css`
  ${Spacing.mb8}
  ${TextAlign.center}
  ${JustifyContent.center}
  ${Font.md}
  color: ${Color.Gray7};
`;

export const signatureWrapper = css`
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    .ant-card-body {
      ${Spacing.p8}
    }
  }
`;

export const signatureLabel = css`
  ${FontWeight.bold}
  ${Font.md}
  ${Display.flex}
  ${AlignItems.center}
  ${Spacing.my12}
`;

export const signature = css`
  height: 2.5rem; !important;
  max-width: 100%;
  width: 100%;
`;

export const otherFactors = css`
  color: ${Color.Brand6};
  ${FontWeight.bold}
  cursor: pointer;
`;

/** `SpaceSize` with `!important` because `Spacing.px24` cannot beat MButton's `padding: 8px !important`. */
export const reviewDisclosureButton = css`
  &.ant-btn {
    ${Spacing.px24}
  }
`;
